<script setup lang="ts">
import { Link } from '@inertiajs/vue3';
import { computed } from 'vue';

const props = defineProps<{
    href?: string;
    target?: string;
    type?: 'button' | 'submit' | 'reset';
    width?: 'full' | 'auto';
    pill?: boolean;
}>();

const tag = computed(() => {
    if (!props.href) return 'button';
    if (props.target === '_blank') return 'a';
    return Link;
});
const tagAttrs = computed(() => (props.href ? { href: props.href, target: props.target } : { type: props.type ?? 'button' }));
</script>

<template>
    <component
        :is="tag"
        v-bind="tagAttrs"
        :class="{
            'w-full': props.width === 'full',
            'w-auto': props.width === 'auto',
            'rounded-full': props.pill,
            'rounded-md': !props.pill,
        }"
        class="flex items-center justify-center gap-2 p-4 text-center leading-4.5 antialiased"
    >
        <span>
            <slot />
        </span>
    </component>
</template>
